import { render, staticRenderFns } from "./JCard.vue?vue&type=template&id=4846b682&scoped=true&"
import script from "./JCard.vue?vue&type=script&lang=js&"
export * from "./JCard.vue?vue&type=script&lang=js&"
import style0 from "./JCard.vue?vue&type=style&index=0&id=4846b682&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4846b682",
  null
  
)

export default component.exports